export const PHONE_INPUT_OUTPUT_TYPE_JSON = 'json';
export const PHONE_INPUT_OUTPUT_TYPE_STRING = 'string';
